(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buildsystem-print"] && !Shopify.designMode) return;
  try {
    
(function () {
  function cleanOneLine(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  function decodeNewlines(s) {
    return String(s || '')
      .replace(/&amp;#10;/g, '\n')
      .replace(/&#10;/g, '\n')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n')
      .trim();
  }

  function wrapText(text, font, fontSize, maxWidth) {
    if (!text) return [];
    var words = String(text).split(/\s+/);
    var lines = [];
    var line = '';

    for (var i = 0; i < words.length; i++) {
      var test = line ? line + ' ' + words[i] : words[i];
      var w = font.widthOfTextAtSize(test, fontSize);
      if (w <= maxWidth) line = test;
      else { if (line) lines.push(line); line = words[i]; }
    }
    if (line) lines.push(line);
    return lines;
  }

  function wrapTextPreserveNewlines(text, font, fontSize, maxWidth) {
    if (!text) return [];
    var parts = String(text).split('\n');
    var out = [];

    for (var i = 0; i < parts.length; i++) {
      var p = (parts[i] || '').trim();
      if (!p) { out.push(''); continue; }
      var wrapped = wrapText(p, font, fontSize, maxWidth);
      for (var j = 0; j < wrapped.length; j++) out.push(wrapped[j]);
    }

    while (out.length && out[0] === '') out.shift();
    while (out.length && out[out.length - 1] === '') out.pop();
    return out;
  }

  function looksLikeSvgUrl(url) {
    if (!url) return false;
    var u = String(url).toLowerCase();
    if (u.indexOf('data:image/svg+xml') === 0) return true;
    u = u.split('#')[0].split('?')[0];
    return u.endsWith('.svg');
  }

  function withMinShopifyWidth(url, minWidth) {
    try {
      if (!url) return url;
      var u = new URL(url, window.location.href);
      if (!/cdn\.shopify\.com$/i.test(u.hostname)) return url;

      var current = parseInt(u.searchParams.get('width') || '0', 10);
      if (!current || current < minWidth) u.searchParams.set('width', String(minWidth));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function parseSvgSize(svgText) {
    try {
      var doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
      var svg = doc.querySelector('svg');
      if (!svg) return { w: 1400, h: 550 };

      var wAttr = svg.getAttribute('width');
      var hAttr = svg.getAttribute('height');
      var vb = svg.getAttribute('viewBox');

      function parseLen(v) {
        if (!v) return 0;
        var n = parseFloat(String(v).replace(/px$/i, '').trim());
        return isFinite(n) ? n : 0;
      }

      var w = parseLen(wAttr);
      var h = parseLen(hAttr);

      if ((!w || !h) && vb) {
        var parts = vb.trim().split(/\s+|,/).map(parseFloat);
        if (parts.length === 4 && isFinite(parts[2]) && isFinite(parts[3])) {
          w = w || parts[2];
          h = h || parts[3];
        }
      }

      if (!w || !h) { w = w || 1400; h = h || 550; }
      return { w: w, h: h };
    } catch (e) {
      return { w: 1400, h: 550 };
    }
  }

  function svgTextToDataUrl(svgText) {
    var encoded = encodeURIComponent(svgText)
      .replace(/%0A/g, '')
      .replace(/%20/g, ' ')
      .replace(/%3D/g, '=')
      .replace(/%3A/g, ':')
      .replace(/%2F/g, '/');
    return 'data:image/svg+xml;charset=utf-8,' + encoded;
  }

  function loadImage(src) {
    return new Promise(function(resolve, reject) {
      var img = new Image();
      img.onload = function () { resolve(img); };
      img.onerror = reject;
      img.src = src;
    });
  }

  function loadPdfLib() {
    return new Promise(function (resolve, reject) {
      if (window.PDFLib && window.PDFLib.PDFDocument) return resolve(window.PDFLib);

      var existing = document.querySelector('script[data-pdf-lib]');
      if (existing) {
        existing.addEventListener('load', function(){ resolve(window.PDFLib); });
        existing.addEventListener('error', reject);
        return;
      }

      var s = document.createElement('script');
      s.src = 'https://unpkg.com/pdf-lib@1.17.1/dist/pdf-lib.min.js';
      s.async = true;
      s.setAttribute('data-pdf-lib', 'true');
      s.onload = function () {
        if (window.PDFLib && window.PDFLib.PDFDocument) resolve(window.PDFLib);
        else reject(new Error('PDFLib failed to load'));
      };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  async function fetchAsArrayBuffer(url) {
    var res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error('Fetch failed: ' + res.status);
    return await res.arrayBuffer();
  }

  async function fetchAsText(url) {
    var res = await fetch(url, { mode: 'cors' });
    if (!res.ok) throw new Error('Fetch failed: ' + res.status);
    return await res.text();
  }

  async function svgUrlToJpgBytes(svgUrl, targetPixelWidth, jpegQuality) {
    var svgText = await fetchAsText(svgUrl);
    var size = parseSvgSize(svgText);
    var ratio = size.h / size.w;

    var outW = Math.max(800, Math.round(targetPixelWidth || 3600));
    var outH = Math.max(400, Math.round(outW * ratio));

    var canvas = document.createElement('canvas');
    canvas.width = outW;
    canvas.height = outH;

    var ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, outW, outH);

    var dataUrl = svgTextToDataUrl(svgText);
    var img = await loadImage(dataUrl);

    var bleed = 2;
    ctx.drawImage(img, -bleed, -bleed, outW + (bleed * 2), outH + (bleed * 2));

    var q = (typeof jpegQuality === 'number') ? jpegQuality : 0.92;

    var blob = await new Promise(function(resolve) {
      canvas.toBlob(function(b){ resolve(b); }, 'image/jpeg', q);
    });
    if (!blob) throw new Error('SVG rasterization failed (JPEG blob)');

    var ab = await blob.arrayBuffer();
    return new Uint8Array(ab);
  }

  async function embedImageAny(pdfDoc, url, opts) {
    if (!url) return null;

    if (looksLikeSvgUrl(url)) {
      var targetW = (opts && opts.svgRasterWidth) ? opts.svgRasterWidth : 3600;
      var q = (opts && typeof opts.jpegQuality === 'number') ? opts.jpegQuality : 0.92;
      var jpgBytes = await svgUrlToJpgBytes(url, targetW, q);
      return await pdfDoc.embedJpg(jpgBytes);
    }

    var bytes = await fetchAsArrayBuffer(url);
    try { return await pdfDoc.embedPng(bytes); }
    catch (e) { return await pdfDoc.embedJpg(bytes); }
  }

  function collectSelections() {
    var cards = document.querySelectorAll('.buildsystem-product__card');
    var items = [];

    cards.forEach(function (card) {
      var qtyEl = card.querySelector('input[id^="qty-"]');
      var qty = qtyEl ? parseInt(qtyEl.value || '0', 10) : 0;
      if (!qty || qty <= 0) return;

      var part = (card.getAttribute('data-printout-part-number') || '').trim();
      var desc = (card.getAttribute('data-printout-description') || '').trim();
      var qr = (card.getAttribute('data-printout-qr') || '').trim();
      var instructionalUrl = (card.getAttribute('data-printout-instructional-url') || '').trim();

      if (!part) {
        var handle = (card.getAttribute('data-product-handle') || '').trim();
        part = handle ? handle : 'Part';
      }

      if (!desc) {
        var titleEl = card.querySelector('.card__content h3');
        desc = titleEl && titleEl.childNodes && titleEl.childNodes[0]
          ? (titleEl.childNodes[0].textContent || '').trim()
          : 'Description';
      }

      items.push({
        part: part,
        desc: desc,
        qty: qty,
        qr: qr,
        instructionalUrl: instructionalUrl
      });
    });

    return { items: items };
  }

  function findCardByPart(part) {
    var cards = document.querySelectorAll('.buildsystem-product__card');
    var match = null;

    cards.forEach(function(card){
      if (match) return;

      var p = (card.getAttribute('data-printout-part-number') || '').trim();
      if (!p) {
        var handle = (card.getAttribute('data-product-handle') || '').trim();
        p = handle ? handle : '';
      }

      if (p && p === part) match = card;
    });

    return match;
  }

  function setQtyForPart(part, qty) {
    var card = findCardByPart(part);
    if (!card) return;

    var input = card.querySelector('input[id^="qty-"]');
    if (!input) return;

    var newVal = Math.max(0, Math.min(99, parseInt(qty || '0', 10) || 0));
    input.value = String(newVal);

    try {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } catch(e) {}
  }

  function escHtml(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatDdMmYy(dateObj) {
    var d = dateObj.getDate();
    var m = dateObj.getMonth() + 1;
    var y = dateObj.getFullYear() % 100;

    var dd = String(d).padStart(2, '0');
    var mm = String(m).padStart(2, '0');
    var yy = String(y).padStart(2, '0');

    return mm + '-' + dd + '-' + yy;
  }

  function safeFilename(name) {
    return String(name || '')
      .replace(/[\/\\?%*:|"<>]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildPdfFilename(patientName, dateObj) {
    var stamp = formatDdMmYy(dateObj);
    var cleanName = cleanOneLine(patientName);

    if (cleanName) {
      var base = cleanName + ' - Bellman System - ' + stamp;
      return safeFilename(base) + '.pdf';
    }
    return safeFilename('Bellman System - ' + stamp) + '.pdf';
  }

  function initOnePrintout(sectionEl) {
    var cartPill = sectionEl.querySelector('[data-buildsystem-printout]');
    var stickyBtn = sectionEl.querySelector('[data-sticky-primary]');

    var summaryWrap = sectionEl.querySelector('[data-buildsystem-summary]');
    var summaryBody = sectionEl.querySelector('[data-summary-body]');
    var summaryName = sectionEl.querySelector('[data-summary-patient-name]');
    var summaryNotes = sectionEl.querySelector('[data-summary-notes]');
    var summaryDownloadBtn = sectionEl.querySelector('[data-download-from-summary]');

    var modal = sectionEl.querySelector('[data-buildsystem-modal]');
    var modalCloseEls = sectionEl.querySelectorAll('[data-modal-close]');
    var modalDownloadBtn = sectionEl.querySelector('[data-download-from-modal]');
    var nameInput = sectionEl.querySelector('[data-patient-name]');
    var notesInput = sectionEl.querySelector('[data-provider-notes]');

    if (!cartPill || !stickyBtn || !summaryWrap || !summaryBody || !summaryDownloadBtn || !modal || !modalDownloadBtn) return;

    var footer = document.querySelector('footer');
    var headerSection = document.querySelector('.section-header');
    var headerDrawerDetails = document.getElementById('Details-menu-drawer-container');
    var footerInView = false;
    var summaryInView = false;

    function getAttr(name) { return cartPill.getAttribute(name) || ''; }

    function getPrintHeaderBase() { return cleanOneLine(getAttr('data-print-header')); }
    function getPrintBody() { return decodeNewlines(getAttr('data-print-body')); }
    function getPrintFooterPage1() { return decodeNewlines(getAttr('data-print-footer-page-1')); }
    function getPrintFooterPage2() { return decodeNewlines(getAttr('data-print-footer-page-2')); }
    function getPrintImage() { return cleanOneLine(getAttr('data-print-image')); }
    function getPrintImage2() { return cleanOneLine(getAttr('data-print-image-2')); }

    function isAnyHeaderOpen() {
      var bodyMenuLocked =
        document.body.classList.contains('overflow-hidden-mobile') ||
        document.body.classList.contains('overflow-hidden-tablet') ||
        document.body.classList.contains('overflow-hidden-desktop');
      var bodyInlineLocked = String(document.body.style.overflow || '').toLowerCase() === 'hidden';

      var themeDrawerOpen = !!(headerDrawerDetails && headerDrawerDetails.hasAttribute('open'));
      var themeHeaderOpen = !!(headerSection && headerSection.classList.contains('menu-open'));
      var themeHeaderDetailsOpen = !!document.querySelector('.section-header details[open]');

      var hsMirrorMobileOpen = !!document.querySelector('[data-hs-mobile-overlay][data-open="true"]');
      var hsMirrorDesktopOpen = !!document.querySelector('[data-hs-dd][data-open="true"]');

      var customHeaderMobileOpen =
        !!document.querySelector('[class*="ai-custom-header-mobile-nav-"].active') ||
        !!document.querySelector('[class*="ai-custom-header-mobile-menu-"][aria-expanded="true"]');

      return (
        bodyMenuLocked ||
        bodyInlineLocked ||
        themeDrawerOpen ||
        themeHeaderOpen ||
        themeHeaderDetailsOpen ||
        hsMirrorMobileOpen ||
        hsMirrorDesktopOpen ||
        customHeaderMobileOpen
      );
    }

    function applyCartVisibilityForState() {
      if (footerInView || summaryInView || isAnyHeaderOpen()) {
        cartPill.classList.add('floating-cart--hidden');
        cartPill.setAttribute('aria-hidden', 'true');
      } else {
        cartPill.classList.remove('floating-cart--hidden');
        cartPill.setAttribute('aria-hidden', 'false');
      }
    }

    if (headerDrawerDetails) {
      headerDrawerDetails.addEventListener('toggle', applyCartVisibilityForState);
    }

    if ('MutationObserver' in window) {
      var headerStateObserver = new MutationObserver(function () {
        applyCartVisibilityForState();
      });

      headerStateObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      headerStateObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });

      if (headerSection) {
        headerStateObserver.observe(headerSection, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'open', 'aria-expanded', 'data-open']
        });
      }

      document.querySelectorAll('[data-hs-mobile-overlay], [data-hs-dd], [class*="ai-custom-header-mobile-nav-"], [class*="ai-custom-header-mobile-menu-"]').forEach(function (el) {
        headerStateObserver.observe(el, {
          attributes: true,
          attributeFilter: ['class', 'open', 'aria-expanded', 'data-open', 'aria-hidden']
        });
      });
    }

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      try { nameInput && nameInput.focus(); } catch (e) {}
      if (window.BSNVeteranMeasurement) window.BSNVeteranMeasurement.review();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      try { stickyBtn.focus(); } catch (e) {}
    }

    modalCloseEls.forEach(function (el) {
      el.addEventListener('click', function () { closeModal(); });
    });

    modal.addEventListener('click', function (e) {
      if (!modal.classList.contains('is-open')) return;
      var panel = modal.querySelector('.buildsystem-modal__panel');
      if (!panel) return;
      if (!panel.contains(e.target)) closeModal();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
    });

    function renderSummary() {
      var data = collectSelections();
      var items = (data && data.items) ? data.items : [];

      if (!items.length) {
        summaryBody.innerHTML = '<tr><td class="buildsystem-summary__empty" colspan="3"><p>No items selected.</p></td></tr>';
        return;
      }

      var rows = items.map(function(it){
        return (
          '<tr data-part="' + escHtml(it.part) + '">' +
            '<td><p>' + escHtml(it.part) + '</p></td>' +
            '<td title="' + escHtml(it.desc) + '"><p>' + escHtml(it.desc) + '</p></td>' +
            '<td>' +
              '<div class="buildsystem-summary__qty-controls">' +
                '<button type="button" class="buildsystem-summary__qty-btn" data-sum-minus aria-label="Decrease quantity">−</button>' +
                '<p class="buildsystem-summary__qty-val" aria-label="Quantity">' + escHtml(it.qty) + '</p>' +
                '<button type="button" class="buildsystem-summary__qty-btn" data-sum-plus aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</td>' +
          '</tr>'
        );
      }).join('');

      summaryBody.innerHTML = rows;
    }

    function updateButtonState() {
      var d = collectSelections();
      var hasItems = !!(d && d.items && d.items.length);

      stickyBtn.disabled = !hasItems;
      summaryDownloadBtn.disabled = !hasItems;
      modalDownloadBtn.disabled = !hasItems;

      if (hasItems) cartPill.classList.add('floating-cart--active');
      else cartPill.classList.remove('floating-cart--active');

      renderSummary();
    }

    async function generateAndDownloadPdf(patientNameRaw, providerNotesRaw) {
      var data = collectSelections();
      if (!data.items.length) return;

      var patientName = cleanOneLine(patientNameRaw);
      var providerNotes = decodeNewlines(providerNotesRaw);

      var PDFLib = await loadPdfLib();
      var PDFDocument = PDFLib.PDFDocument;
      var StandardFonts = PDFLib.StandardFonts;
      var rgb = PDFLib.rgb;

      var pdfDoc = await PDFDocument.create();
      var font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      var fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

      // ===== QR SHEET CLICKABLE HOTSPOT (per-item URL) =====
      var QR_IMG_W = 1720;
      var QR_IMG_H = 985;

      var QR_BOX_X = 98.5;
      var QR_BOX_Y = 769.5;
      var QR_BOX_W = 545.9;
      var QR_BOX_H = 150;

      function ensureHttps(url) {
        var u = String(url || '').trim();
        if (!u) return '';
        if (!/^https?:\/\//i.test(u)) u = 'https://' + u;
        return u;
      }

      function addLinkRect(page, x, y, w, h, url) {
        try {
          url = ensureHttps(url);
          if (!url) return;

          var PDFName = PDFLib.PDFName;
          var PDFArray = PDFLib.PDFArray;
          var PDFNumber = PDFLib.PDFNumber;
          var PDFString = PDFLib.PDFString;

          var annots = page.node.lookup(PDFName.of('Annots'), PDFArray);
          if (!annots) {
            annots = pdfDoc.context.obj([]);
            page.node.set(PDFName.of('Annots'), annots);
          }

          var rect = pdfDoc.context.obj([
            PDFNumber.of(x),
            PDFNumber.of(y),
            PDFNumber.of(x + w),
            PDFNumber.of(y + h)
          ]);

          var border = pdfDoc.context.obj([PDFNumber.of(0), PDFNumber.of(0), PDFNumber.of(0)]);

          var action = pdfDoc.context.obj({
            Type: PDFName.of('Action'),
            S: PDFName.of('URI'),
            URI: PDFString.of(url)
          });

          var annot = pdfDoc.context.obj({
            Type: PDFName.of('Annot'),
            Subtype: PDFName.of('Link'),
            Rect: rect,
            Border: border,
            H: PDFName.of('I'),
            A: action
          });

          var ref = pdfDoc.context.register(annot);
          annots.push(ref);
        } catch (e) {
          console.warn('addLinkRect failed:', e);
        }
      }

      function addQrHotspotOverDrawnImage(page, imgDrawX, imgDrawY, imgDrawW, imgDrawH, url) {
        url = ensureHttps(url);
        if (!url) return;

        var sx = imgDrawW / QR_IMG_W;
        var sy = imgDrawH / QR_IMG_H;

        var linkX = imgDrawX + (QR_BOX_X * sx);
        var linkW = QR_BOX_W * sx;

        var yFromBottomInSrc = QR_IMG_H - (QR_BOX_Y + QR_BOX_H);
        var linkY = imgDrawY + (yFromBottomInSrc * sy);
        var linkH = QR_BOX_H * sy;

        if (linkW <= 0 || linkH <= 0) return;

        addLinkRect(page, linkX, linkY, linkW, linkH, url);
      }

      var pageWidth = 612;
      var pageHeight = 792;
      var margin = 48;

      var titleSize = 18;
      var bodySize = 11;

      var footerImgMaxW = 150;
      var footerImgScaleDown = 0.60;

      var embedCache = Object.create(null);
      async function getEmbedded(url, opts) {
        if (!url) return null;
        var key = url
          + (opts && opts.svgRasterWidth ? ('|svgw=' + opts.svgRasterWidth) : '')
          + (opts && typeof opts.jpegQuality === 'number' ? ('|q=' + opts.jpegQuality) : '');
        if (embedCache[key]) return embedCache[key];
        var emb = await embedImageAny(pdfDoc, url, opts);
        embedCache[key] = emb;
        return emb;
      }

      function buildHeaderText() {
        var base = getPrintHeaderBase();
        if (!patientName) return base;
        return patientName + ' | ' + base;
      }

      function drawHeaderCommon(page, headerText, bodyText, yStart) {
        page.drawText(headerText || '', {
          x: margin,
          y: yStart - titleSize,
          size: titleSize,
          font: fontBold,
          color: rgb(0, 0, 0)
        });

        var bodyMaxW = pageWidth - margin * 2;
        var bodyLines = wrapTextPreserveNewlines(bodyText || '', font, bodySize, bodyMaxW);

        for (var i = 0; i < bodyLines.length; i++) {
          var line = bodyLines[i];
          if (!line) continue;
          page.drawText(line, {
            x: margin,
            y: (yStart - titleSize - 18) - (i * 14),
            size: bodySize,
            font: font,
            color: rgb(0, 0, 0)
          });
        }

        var bodyBlockH = Math.max(1, bodyLines.length) * 14;
        var y = (yStart - titleSize - 18) - bodyBlockH - 8;

        page.drawLine({
          start: { x: margin, y: y },
          end: { x: pageWidth - margin, y: y },
          thickness: 1,
          color: rgb(0.8, 0.8, 0.8)
        });

        return y - 18;
      }

      async function drawFooter(page, footerText, footerImageUrl) {
        var footerBaseY = margin - 22;
        var footerTextX = margin;
        var footerMaxW = pageWidth - margin * 2;

        var embeddedImg = null;
        try {
          embeddedImg = await getEmbedded(footerImageUrl, { svgRasterWidth: 2000, jpegQuality: 0.92 });
        } catch (e) { embeddedImg = null; }

        if (embeddedImg) {
          var imgW = embeddedImg.width;
          var scaleToMax = imgW > 0 ? Math.min(1, footerImgMaxW / imgW) : 1;
          var scale = scaleToMax * footerImgScaleDown;

          var drawW = imgW * scale;
          var imgX = (pageWidth - margin) - drawW;

          page.drawImage(embeddedImg, {
            x: imgX,
            y: footerBaseY,
            width: Math.round(drawW),
            height: Math.round(embeddedImg.height * scale)
          });

          footerMaxW = (imgX - 12) - footerTextX;
          if (footerMaxW < 140) footerMaxW = pageWidth - margin * 2;
        }

        var footerLines = wrapTextPreserveNewlines(footerText || '', font, bodySize, footerMaxW);

        var lineH = 14;
        var textStartY = footerBaseY + Math.max(0, (footerLines.length - 1) * lineH);

        for (var f = 0; f < footerLines.length; f++) {
          var fl = footerLines[f];
          if (!fl) continue;
          page.drawText(fl, {
            x: footerTextX,
            y: textStartY - (f * lineH),
            size: bodySize,
            font: font,
            color: rgb(0.35, 0.35, 0.35)
          });
        }
      }

      function drawNotesBox(page, notesText, yCursor) {
        if (!notesText) return yCursor;

        var boxW = pageWidth - margin * 2;
        var innerPad = 10;
        var labelH = 14;
        var lineH = 13;

        var innerW = boxW - (innerPad * 2);
        var lines = wrapTextPreserveNewlines(notesText, font, bodySize, innerW);

        var contentH = Math.max(1, lines.length) * lineH;
        var boxH = innerPad + labelH + 6 + contentH + innerPad;

        var minBottom = margin + 70;
        if ((yCursor - boxH) < minBottom) return null;

        var yTop = yCursor;
        var yBottom = yTop - boxH;

        page.drawRectangle({
          x: margin,
          y: yBottom,
          width: boxW,
          height: boxH,
          borderColor: rgb(0.85, 0.85, 0.85),
          borderWidth: 1
        });

        page.drawText('Notes:', {
          x: margin + innerPad,
          y: yTop - innerPad - labelH + 2,
          size: bodySize,
          font: fontBold,
          color: rgb(0, 0, 0)
        });

        var textYStart = yTop - innerPad - labelH - 18;
        for (var i = 0; i < lines.length; i++) {
          var ln = lines[i];
          if (!ln) continue;
          page.drawText(ln, {
            x: margin + innerPad,
            y: textYStart - (i * lineH),
            size: bodySize,
            font: font,
            color: rgb(0, 0, 0)
          });
        }

        return yBottom - 14;
      }

      // PAGE 1 (table)
      var page1 = pdfDoc.addPage([pageWidth, pageHeight]);
      var y1 = pageHeight - margin;

      y1 = drawHeaderCommon(page1, buildHeaderText(), getPrintBody(), y1);

      var tableW = pageWidth - margin * 2;
      var qtyW = 44;
      var gutter = 10;

      var partHeader = 'Part Number';
      var partW = fontBold.widthOfTextAtSize(partHeader, bodySize) + 10;

      var colPartX = margin;
      var colQtyX = margin + tableW - qtyW;
      var colDescX = colPartX + partW + gutter;

      var descW = colQtyX - gutter - colDescX;
      if (descW < 120) descW = 120;

      function drawTableHeader() {
        page1.drawText('Part Number', { x: colPartX, y: y1, size: bodySize, font: fontBold });
        page1.drawText('Description', { x: colDescX, y: y1, size: bodySize, font: fontBold });

        var qtyHeader = 'Qty';
        page1.drawText(qtyHeader, {
          x: colQtyX + qtyW - 6 - fontBold.widthOfTextAtSize(qtyHeader, bodySize),
          y: y1,
          size: bodySize,
          font: fontBold
        });

        y1 -= 10;
        page1.drawLine({
          start: { x: margin, y: y1 },
          end: { x: pageWidth - margin, y: y1 },
          thickness: 1,
          color: rgb(0.8, 0.8, 0.8)
        });
        y1 -= 14;
      }

      function newTablePage() {
        page1 = pdfDoc.addPage([pageWidth, pageHeight]);
        y1 = pageHeight - margin;
        y1 = drawHeaderCommon(page1, buildHeaderText(), getPrintBody(), y1);
        drawTableHeader();
      }

      function drawRow(item) {
        var partLines = wrapText(item.part, font, bodySize, partW);
        var descLines = wrapText(item.desc, font, bodySize, descW);
        var linesCount = Math.max(partLines.length || 1, descLines.length || 1);
        var rowHeight = Math.max(16, linesCount * 13);

        if (y1 - rowHeight < margin + 120) newTablePage();

        for (var i = 0; i < linesCount; i++) {
          var p = partLines[i] || (i === 0 ? item.part : '');
          var d = descLines[i] || (i === 0 ? item.desc : '');
          if (p) page1.drawText(p, { x: colPartX, y: y1 - (i * 13), size: bodySize, font: font });
          if (d) page1.drawText(d, { x: colDescX, y: y1 - (i * 13), size: bodySize, font: font });
        }

        var qtyStr = String(item.qty);
        page1.drawText(qtyStr, {
          x: colQtyX + qtyW - 6 - font.widthOfTextAtSize(qtyStr, bodySize),
          y: y1,
          size: bodySize,
          font: font
        });

        y1 -= rowHeight;

        page1.drawLine({
          start: { x: margin, y: y1 + 6 },
          end: { x: pageWidth - margin, y: y1 + 6 },
          thickness: 0.8,
          color: rgb(0.9, 0.9, 0.9)
        });

        y1 -= 10;
      }

      drawTableHeader();
      data.items.forEach(drawRow);

      if (providerNotes) {
        var yAfter = drawNotesBox(page1, providerNotes, y1);
        if (yAfter === null) {
          await drawFooter(page1, getPrintFooterPage1(), getPrintImage());
          page1 = pdfDoc.addPage([pageWidth, pageHeight]);
          y1 = pageHeight - margin;
          y1 = drawHeaderCommon(page1, buildHeaderText(), getPrintBody(), y1);
          var y2 = drawNotesBox(page1, providerNotes, y1);
          if (typeof y2 === 'number') y1 = y2;
        } else {
          y1 = yAfter;
        }
      }

      await drawFooter(page1, getPrintFooterPage1(), getPrintImage());

      // PAGE 2+ (images)
      var qrItems = (data.items || []).filter(function (it) { return it && it.qr; });

      if (qrItems.length) {
        var contentW2 = pageWidth - margin * 2;
        var topPadNoHeader = 12;

        var maxImgW = contentW2;
        var bottomLimit = margin + 75;

        var afterImageGap = 10;
        var afterDividerGap = 6;
        var dividerStroke = 1;

        var yStartImages = pageHeight - margin - topPadNoHeader;
        var availableH = yStartImages - bottomLimit;
        var betweenTwoImagesH = afterImageGap + dividerStroke + afterDividerGap;

        var maxImgH = Math.floor((availableH - betweenTwoImagesH) / 2);
        if (!isFinite(maxImgH) || maxImgH < 120) maxImgH = 120;

        var qrMinShopifyWidth = 2500;
        var qrSvgRasterWidth = 3000;
        var qrSvgJpegQuality = 0.89;

        function newImagePage() {
          var p = pdfDoc.addPage([pageWidth, pageHeight]);
          var yCursor = yStartImages;
          return { page: p, yCursor: yCursor, slotsLeft: 2 };
        }

        function ensureRoomForOne(state, neededHeight) {
          return (state.yCursor - neededHeight) >= bottomLimit;
        }

        function ensureRoomForImagePlusNext(state, thisImageH) {
          if (state.slotsLeft <= 1) return true;
          var needed = thisImageH + afterImageGap + afterDividerGap + maxImgH;
          return (state.yCursor - needed) >= bottomLimit;
        }

        var state = newImagePage();

        for (var idx = 0; idx < qrItems.length; idx++) {
          var item2 = qrItems[idx];

          if (state.slotsLeft <= 0) {
            await drawFooter(state.page, getPrintFooterPage2(), getPrintImage2());
            state = newImagePage();
          }

          if (!ensureRoomForOne(state, maxImgH)) {
            await drawFooter(state.page, getPrintFooterPage2(), getPrintImage2());
            state = newImagePage();
          }

          var rawUrl = item2.qr;
          var qrUrl = looksLikeSvgUrl(rawUrl) ? rawUrl : withMinShopifyWidth(rawUrl, qrMinShopifyWidth);

          var imgEmb = null;
          try {
            imgEmb = await getEmbedded(
              qrUrl,
              looksLikeSvgUrl(qrUrl) ? { svgRasterWidth: qrSvgRasterWidth, jpegQuality: qrSvgJpegQuality } : null
            );
          } catch (e) {
            imgEmb = null;
          }
          if (!imgEmb) continue;

          var iw = imgEmb.width;
          var ih = imgEmb.height;

          var sW = iw > 0 ? (maxImgW / iw) : 1;
          var sH = ih > 0 ? (maxImgH / ih) : 1;
          var s = Math.min(1, sW, sH);

          var dW = iw * s;
          var dH = ih * s;

          var hasMoreItems = (idx < qrItems.length - 1);

          if (hasMoreItems && state.slotsLeft > 1 && !ensureRoomForImagePlusNext(state, dH)) {
            await drawFooter(state.page, getPrintFooterPage2(), getPrintImage2());
            state = newImagePage();
          }

          if (!ensureRoomForOne(state, dH)) {
            await drawFooter(state.page, getPrintFooterPage2(), getPrintImage2());
            state = newImagePage();
          }
          if (!ensureRoomForOne(state, dH)) continue;

          var drawW = Math.round(dW);
          var drawH = Math.round(dH);
          var x = Math.round(margin + (contentW2 - drawW) / 2);
          var y = Math.round(state.yCursor - drawH);

          state.page.drawImage(imgEmb, { x: x, y: y, width: drawW, height: drawH });

          if (item2.instructionalUrl) {
            addQrHotspotOverDrawnImage(state.page, x, y, drawW, drawH, item2.instructionalUrl);
          }

          state.yCursor = y - afterImageGap;
          state.slotsLeft -= 1;

          if (hasMoreItems && state.slotsLeft > 0) {
            state.page.drawLine({
              start: { x: margin, y: state.yCursor },
              end: { x: pageWidth - margin, y: state.yCursor },
              thickness: dividerStroke,
              color: rgb(0.8, 0.8, 0.8)
            });
            state.yCursor -= afterDividerGap;
          }
        }

        await drawFooter(state.page, getPrintFooterPage2(), getPrintImage2());
      }

      var outBytes = await pdfDoc.save();
      var blob = new Blob([outBytes], { type: 'application/pdf' });
      var url = URL.createObjectURL(blob);

      var a = document.createElement('a');
      a.href = url;

      var today = new Date();
      a.download = buildPdfFilename(patientName, today);

      document.body.appendChild(a);
      a.click();
      a.remove();
      if (window.BSNVeteranMeasurement) window.BSNVeteranMeasurement.pdfComplete();

      setTimeout(function () {
        try { URL.revokeObjectURL(url); } catch (e) {}
      }, 60000);
    }

    // Sticky click behavior depends on summary visibility
    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;

      if (summaryInView) {
        var patientName = summaryName ? summaryName.value : '';
        var notes = summaryNotes ? summaryNotes.value : '';

        stickyBtn.disabled = true;
        generateAndDownloadPdf(patientName, notes)
          .catch(function (err) {
            if (window.BSNVeteranMeasurement) window.BSNVeteranMeasurement.pdfError();
            console.error('PDF generation failed:', err);
          })
          .finally(function () { stickyBtn.disabled = false; updateButtonState(); });
      } else {
        openModal();
      }
    });

    // Modal download
    modalDownloadBtn.addEventListener('click', function () {
      var patientName = nameInput ? nameInput.value : '';
      var notes = notesInput ? notesInput.value : '';

      modalDownloadBtn.disabled = true;

      generateAndDownloadPdf(patientName, notes)
        .then(function () { closeModal(); })
        .catch(function (err) {
          if (window.BSNVeteranMeasurement) window.BSNVeteranMeasurement.pdfError();
          console.error('PDF generation failed:', err);
        })
        .finally(function () { modalDownloadBtn.disabled = false; updateButtonState(); });
    });

    // Summary download
    summaryDownloadBtn.addEventListener('click', function () {
      var patientName = summaryName ? summaryName.value : '';
      var notes = summaryNotes ? summaryNotes.value : '';

      summaryDownloadBtn.disabled = true;

      generateAndDownloadPdf(patientName, notes)
        .catch(function (err) {
          if (window.BSNVeteranMeasurement) window.BSNVeteranMeasurement.pdfError();
          console.error('PDF generation failed:', err);
        })
        .finally(function () { summaryDownloadBtn.disabled = false; updateButtonState(); });
    });

    // Summary qty +/- delegation
    summaryWrap.addEventListener('click', function(e){
      var minus = e.target && e.target.closest('[data-sum-minus]');
      var plus = e.target && e.target.closest('[data-sum-plus]');
      if (!minus && !plus) return;

      var row = e.target.closest('tr[data-part]');
      if (!row) return;

      var part = row.getAttribute('data-part') || '';
      if (!part) return;

      var current = 0;
      try {
        current = parseInt(row.querySelector('.buildsystem-summary__qty-val').textContent || '0', 10) || 0;
      } catch(err){ current = 0; }

      var next = current + (plus ? 1 : -1);
      next = Math.max(0, Math.min(99, next));

      setQtyForPart(part, next);
      updateButtonState();
    });

    // Make sticky visible
    cartPill.classList.add('floating-cart--visible');
    cartPill.setAttribute('aria-hidden', 'false');

    if ('IntersectionObserver' in window) {
      var summaryObserver = new IntersectionObserver(function(entries){
        summaryInView = entries.some(function(en){ return en.isIntersecting; });
        applyCartVisibilityForState();
      }, { threshold: 0.12 });

      summaryObserver.observe(summaryWrap);

      if (footer) {
        var footerObserver = new IntersectionObserver(function(entries){
          footerInView = entries.some(function(en){ return en.isIntersecting; });
          applyCartVisibilityForState();
        }, { threshold: 0.05 });

        footerObserver.observe(footer);
      }
    }

    if (summaryName && nameInput) {
      summaryName.addEventListener('input', function(){ nameInput.value = summaryName.value; });
      nameInput.addEventListener('input', function(){ summaryName.value = nameInput.value; });
    }
    if (summaryNotes && notesInput) {
      summaryNotes.addEventListener('input', function(){ notesInput.value = summaryNotes.value; });
      notesInput.addEventListener('input', function(){ summaryNotes.value = notesInput.value; });
    }

    document.addEventListener('input', function (e) {
      if (e.target && e.target.matches('input[id^="qty-"]')) updateButtonState();
    });

    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest('.qty-btn')) setTimeout(updateButtonState, 0);
    });

    updateButtonState();
    applyCartVisibilityForState();
  }

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.buildsystem-printout[data-sticky-cart]');
    sections.forEach(function (sectionEl) {
      initOnePrintout(sectionEl);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
